// extracted by mini-css-extract-plugin
export var fileExt = "_sp-8";
export var fileIcon = "_sp-6";
export var fileLink = "_sp-5";
export var fileName = "_sp-7";
export var image = "_sp-1";
export var imageError = "_sp-3";
export var imageErrorIcon = "_sp-4";
export var imageLink = "_sp-0";
export var imageLoaded = "_sp-2";